import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Tabs } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
import GroupSearchForm from './components/GroupSearchForm'
import GroupSearchResult from './components/GroupSearchResult'
import { PAGE_SIZE_DEFAULT } from '../../constants/appConstant';
const { TabPane } = Tabs;
@inject('indexManagementStore')
@observer
class PermissionManagement extends Component {
  componentDidMount() {
    const { indexManagementStore } = this.props;
    indexManagementStore.onSearchAction(1, PAGE_SIZE_DEFAULT)
  }
  onChange = (value) => {
    const { indexManagementStore } = this.props;
    if (value === 'indexSet') {
      indexManagementStore.onSearchAction(1, PAGE_SIZE_DEFAULT)
    } else {
      indexManagementStore.onSearchGroupAction(1, PAGE_SIZE_DEFAULT)
    }
  }
  render() {
    return (
      <div className="container">
        <Tabs defaultActiveKey="indexSet" onChange={this.onChange} className='messagesTabs'>
          <TabPane tab="Index Set" key="indexSet" style={{ paddingTop: 10 }}>
            <SearchForm />
            <SearchResult />
          </TabPane>
          <TabPane tab="Index Group Set" key="indexGroupSet" style={{ paddingTop: 10 }}>
            <GroupSearchForm />
            <GroupSearchResult />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
export default PermissionManagement;
